import React, { createContext, useContext, useEffect } from 'react';
import { useLocalStorage } from '../hooks/use-local-storage';

type OrderSelectionContext = {
  selectedOrderId: string | null;
  setSelectedOrderId: (orderId: string | null) => void;
};

const OrderSelectionContext = createContext<OrderSelectionContext | null>(null);

export const OrderSelectionProvider = ({ children }: { children: React.ReactNode }) => {
  const [selectedOrderId, setSelectedOrderId] = useLocalStorage<string | null>('pillexa:selectedOrderId', null);

  return (
    <OrderSelectionContext.Provider
      value={{
        selectedOrderId,
        setSelectedOrderId,
      }}
    >
      {children}
    </OrderSelectionContext.Provider>
  );
};

export const useOrderSelection = () => {
  const context = useContext(OrderSelectionContext);
  if (!context) {
    throw new Error('useOrderSelection must be used within OrderSelectionProvider');
  }
  return context;
};
